<script setup lang="ts">
import { WidgetBreadcrumbs } from '~/components/widget/breadcrumbs'
import { WidgetReviveAd } from '~/components/widget/revive-ad'
import { WidgetAboutPageCommentsSuggestions } from '~/components/widget/about-page'
import { WidgetCustomerCare } from '~/components/widget/customer-care'
import { WidgetInstagram } from '~/components/widget/instagram'
import { WidgetStaticPage } from '~/components/widget/static-page'

const { t } = useI18n()
const breadcrumbs = computed(() => [{ title: t('common.for_banks'), url: '/banks-info' }])
</script>

<template>
  <Main>
    <Container>
      <WidgetBreadcrumbs :links="breadcrumbs" />
      <ContentLayout>
        <template #right-sidebar>
          <aside>
            <WidgetCustomerCare />
            <WidgetInstagram />
            <WidgetReviveAd zoneid="27" class="overflow-hidden rounded-lg" />
          </aside>
        </template>
        <div class="lg:col-span-3" role="main">
          <WidgetStaticPage heading-level="h1">
            <WidgetAboutPageCommentsSuggestions />
          </WidgetStaticPage>
        </div>
      </ContentLayout>
    </Container>
  </Main>
</template>
